import { Link } from 'react-router-dom';
import type { Topic } from '@/types/content';

interface TopicCardProps {
  topic: Topic;
  variant?: 'grid' | 'list';
}

export default function TopicCard({ topic, variant = 'grid' }: TopicCardProps) {
  if (variant === 'list') {
    return (
      <article className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row md:p-5">
        <Link
          to={`/topics/${topic.slug}`}
          className="block h-48 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-32 sm:w-52"
        >
          <img
            src={topic.cover}
            alt={`${topic.title} 专题配图`}
            title={`${topic.title} · 秘史专题`}
            className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </Link>
        <div className="flex flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
            <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-800">
              {topic.category}
            </span>
            <span>{topic.date}</span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" aria-hidden="true"></i>
              {topic.readTime}
            </span>
          </div>
          <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950">
            <Link to={`/topics/${topic.slug}`} className="transition-colors hover:text-primary-800">
              {topic.title}
            </Link>
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {topic.excerpt}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {topic.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="text-[11px] text-foreground-500">
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/topics/${topic.slug}`} className="block h-52 w-full overflow-hidden bg-background-200">
        <img
          src={topic.cover}
          alt={`${topic.title} 专题配图`}
          title={`${topic.title} · 秘史专题`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-[1.04]"
        />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-800">
            {topic.category}
          </span>
          <span>{topic.date}</span>
        </div>
        <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
          <Link to={`/topics/${topic.slug}`} className="transition-colors hover:text-primary-800">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
          {topic.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
          <span>{topic.author}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" aria-hidden="true"></i>
            {topic.readTime}
          </span>
        </div>
      </div>
    </article>
  );
}